<template>
  <div>
    <v-btn
      absolute
      dark
      fab
      top
      right
      color="primary"
      style="top:10px;"
      v-if="!isEditAddon"
      @click="toAddAddon()"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <addonForm
      :dialog="addonDialog"
      @setDialog="addonDialog = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
      :form="form"
      :loading_message="loading_message"
    />
    <v-layout row>
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding:0;"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :loading="loading_message"
      :items="addon_list"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td>{{ countItem(props.item) }}</td>
        <td>
          <img :src="props.item.addon_image" height="40" width="40" style="padding-top:5px;" />
        </td>
        <td class="text-xs-left">{{ props.item.addon_title_th }}</td>
        <td class="text-xs-left">{{ props.item.addon_title_en }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn :disabled="isEditAddon" icon slot="activator" @click="editAddon(props.item)">
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn :disabled="isEditAddon" icon slot="activator" @click="deleteAddon(props.item)">
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
          <v-switch
            :disabled="isEditAddon"
            v-model="props.item.addon_active"
            @change="changeStatus(props.item)"
            color="primary"
            style="max-width:50px;margin-top:11px;"
          ></v-switch>
        </td>
      </template>
      <template slot="no-data">
        <div v-if="loading_message==false">No data available</div>
        <div v-else>
          <v-progress-circular :size="30" color="primary" indeterminate></v-progress-circular>Loading data ...
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import addonForm from "./AddonDialogForm";
export default {
  components: {
    addonForm
  },
  data() {
    return {
      search: "",
      form: {},
      loading_message: false,
      addonDialog: false,
      dialog: false,
      editedIndex: -1,
      switch1: true,
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      headers: [
        { text: "No.", value: "num", align: "center", sortable: false },
        { text: "Icon", value: "icon", align: "center", sortable: false },
        {
          text: "Add-on name TH",
          value: "addon_title_th",
          align: "center",
          sortable: false
        },
        {
          text: "Add-on name EN",
          value: "addon_title_en",
          align: "center",
          sortable: false
        },
        { text: "Action", value: "action", align: "center", sortable: false }
      ],
      addons: [
        {
          num: "1",
          name: "ไป-กลับ",
          action: ""
        },
        {
          num: "2",
          name: "เพิ่มกล่องใส่อาหาร",
          action: ""
        }
      ]
    };
  },
  methods: {
    countItem(item) {
      let index = this.addon_list.findIndex(
        res => res.addon_id == item.addon_id
      );
      return index + 1;
    },
    async changeStatus(item) {
      let obj_clone = JSON.parse(JSON.stringify(item));
      delete obj_clone.addon_image;
      let check = await this.$store.dispatch(
        "fetchMessAddonBack/changeStatusAddon",
        obj_clone
      );
      if (check == false) {
        item.addon_active = !item.addon_active;
      }
    },
    deleteAddon(item) {
      confirm("Are you sure you want to delete this Addon?") &&
        this.$store.dispatch("fetchMessAddonBack/deleteAddon", item);
    },
    async toAddAddon() {
      this.form = {
        addon_relation: [],
        addon_image: null
      };
      this.addonDialog = true;
      this.loading_message = true;
      this.form.addon_relation = await this.$store.dispatch(
        "fetchMessAddonBack/getVahicelList"
      );
      this.loading_message = false;
    },
    async editAddon(item) {
      this.addonDialog = true;
      this.loading_message = true;
      this.editedIndex = 1;
      this.form = {
        addon_relation: [],
        addon_image: null
      };
      this.form = await this.$store.dispatch(
        "fetchMessAddonBack/getAddonDetail",
        item
      );
      this.loading_message = false;
    }
  },
  computed: {
    ...mapState({
      addon_list: state => state.fetchMessAddonBack.addon_list
    }),
    ...mapGetters(["isEditAddon"]),
    pages() {
      this.pagination.totalItems = this.addon_list.length;
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  async created() {
    this.loading_message = true;
    await this.$store.dispatch("fetchMessAddonBack/getAddonList");
    this.loading_message = false;
  }
};
</script>